import { action, makeObservable, observable, reaction } from 'mobx';
import { DEFAULT_SELECTED_CARD_TYPE, MAX_CARD_COUNT } from '../hiloCore/constants';
import { soundService } from '../../../services/baseSoundService/soundService';
import { HiloSoundsName } from '../hiloCore/constants/sounds';
import { userInfoStore } from '../../../store/userInfoStore';
import { freeBetStore } from '../../../store/freeBetStore';

class HiloBetsStore {
  isBetsClosed = false;

  isDoSpinStart = false;

  currentCard = DEFAULT_SELECTED_CARD_TYPE;

  prevCard = DEFAULT_SELECTED_CARD_TYPE;

  oddsByCard = {};

  oddsByCurrentCard = {};

  selectedMarket = null;

  selectedCardIndex = null;

  openedCards = {};

  isWin = false;

  isLose = false;

  startAnimationBySelectedCardIndex = null;

  isNextCard = null;

  cashOutWin = null;

  isAllowCashOut = true;

  currentSpinLastCards = [];

  winAmount = null;

  winOdd = null;

  isResultReportSend = false;

  isStopAnimation = false;

  constructor() {
    makeObservable(this, {
      isWin: observable,
      winOdd: observable,
      isLose: observable,
      prevCard: observable,
      winAmount: observable,
      cashOutWin: observable,
      isNextCard: observable,
      oddsByCard: observable,
      currentCard: observable,
      isBetsClosed: observable,
      isDoSpinStart: observable,
      isAllowCashOut: observable,
      selectedMarket: observable,
      isStopAnimation: observable,
      oddsByCurrentCard: observable,
      selectedCardIndex: observable,
      isResultReportSend: observable,
      currentSpinLastCards: observable.deep,
      startAnimationBySelectedCardIndex: observable,
      openedCards: observable.deep,
      setIsWin: action.bound,
      skipCard: action.bound,
      setWinOdd: action.bound,
      setIsLose: action.bound,
      setPrevCard: action.bound,
      setWinAmount: action.bound,
      setIsNextCard: action.bound,
      setCashOutWin: action.bound,
      setOddsByCard: action.bound,
      setOpenedCards: action.bound,
      setCurrentCard: action.bound,
      setIsBetsClosed: action.bound,
      setIsDoSpinStart: action.bound,
      setIsAllowCashOut: action.bound,
      setSelectedMarket: action.bound,
      setIsStopAnimation: action.bound,
      resetSelectedMarket: action.bound,
      setSelectedCardIndex: action.bound,
      setIsResultReportSend: action.bound,
      setCurrentSpinLastCards: action.bound,
      updateCurrentSpinLastCards: action.bound,
      setStartAnimationBySelectedCardIndex: action.bound,
    });
    reaction(
      () => this.isDoSpinStart,
      (value) => {
        const { setIsAllowedChangeCurrency } = userInfoStore;
        setIsAllowedChangeCurrency(!value);
        if (freeBetStore.currentFreeBet && !freeBetStore.currentFreeBet.remainingCount && !value) {
          freeBetStore.setIsShowFreeBetPopup(true);
        }
      }
    );
  }

  setIsStopAnimation(bool) {
    this.isStopAnimation = bool;
  }

  setIsResultReportSend(bool) {
    this.isResultReportSend = bool;
  }

  setWinOdd(odd) {
    this.winOdd = odd;
  }

  setWinAmount(winAmount) {
    this.winAmount = winAmount;
  }

  setCurrentSpinLastCards(cards) {
    this.currentSpinLastCards = cards;
  }

  updateCurrentSpinLastCards(card) {
    this.currentSpinLastCards = [card, ...this.currentSpinLastCards];
  }

  setPrevCard(card) {
    this.prevCard = card;
  }

  setIsAllowCashOut(bool) {
    this.isAllowCashOut = bool;
  }

  setIsNextCard(arg) {
    this.isNextCard = arg;
    setTimeout(() => {
      this.isNextCard = null;
    }, 280);
  }

  setCashOutWin(amount) {
    this.cashOutWin = amount;
  }

  setStartAnimationBySelectedCardIndex(index) {
    this.startAnimationBySelectedCardIndex = index;
    setTimeout(() => {
      this.startAnimationBySelectedCardIndex = null;
    }, 280);
  }

  setIsWin(bool) {
    this.isWin = bool;
  }

  setIsLose(bool) {
    this.isLose = bool;
  }

  setOpenedCards(openedCards) {
    this.openedCards = openedCards;
  }

  setSelectedCardIndex(index) {
    this.selectedCardIndex = index;
  }

  setIsDoSpinStart(bool) {
    this.isDoSpinStart = bool;
  }

  setSelectedMarket(market) {
    if (this.isDoSpinStart && market !== this.selectedMarket) {
      soundService.play(HiloSoundsName.selection);
      this.selectedMarket = market;
    }
  }

  resetSelectedMarket() {
    this.selectedMarket = null;
  }

  setCurrentCard(card) {
    this.setPrevCard(this.currentCard);
    this.currentCard = card;
  }

  setOddsByCurrentCard(odd) {
    this.oddsByCurrentCard = odd;
  }

  setOddsByCard(odds) {
    this.oddsByCard = odds;
    this.setOddsByCurrentCard(odds[this.currentCard]);
  }

  setIsBetsClosed(bool) {
    this.isBetsClosed = bool;
  }

  generateRandomCard() {
    const randomCardType = Math.floor(Math.random() * MAX_CARD_COUNT);
    if (randomCardType === this.currentCard) {
      return this.generateRandomCard();
    }
    return randomCardType;
  }

  skipCard() {
    soundService.play(HiloSoundsName.opening);
    const randomCardType = this.generateRandomCard();
    this.setCurrentCard(randomCardType);
    this.setIsNextCard(true);
    setTimeout(() => {
      this.setOddsByCurrentCard(this.oddsByCard[randomCardType]);
    }, 200);
  }

  resetStore() {
    this.isBetsClosed = false;
    this.isDoSpinStart = false;
    this.currentCard = DEFAULT_SELECTED_CARD_TYPE;
    this.prevCard = DEFAULT_SELECTED_CARD_TYPE;
    this.oddsByCard = {};
    this.oddsByCurrentCard = {};
    this.selectedMarket = null;
    this.selectedCardIndex = null;
    this.openedCards = {};
    this.isWin = false;
    this.isLose = false;
    this.startAnimationBySelectedCardIndex = null;
    this.isNextCard = null;
    this.cashOutWin = null;
    this.isAllowCashOut = true;
    this.currentSpinLastCards = [];
    this.winAmount = null;
    this.winOdd = null;
    this.isResultReportSend = false;
    this.isStopAnimation = false;
  }
}

export const hiloBetsStore = new HiloBetsStore();
